export default __webpack_public_path__ + "static/bajaj-finance-4cc6590a2be96fc2de1230a781cbf027.png";